const config = {
  routes: {
    label: 'Logout',
    prefix: '/logout',
  },
}

export default config
